
export const CAMPAIGN_TYPE_PHONE: string = "PHONE";
export const CAMPAIGN_TYPE_INVENTORY: string = "INVENTORY";